import * as actionDefinitions from './actionDefinitions';

import { SelectedValues } from '../../types/redux/stores/clusterAssignModal.types';

export const showClusterAssignModal = (payload: any) => ({ type: actionDefinitions.SHOW_CLUSTER_MODAL, payload });

export const hideClusterAssignModal = () => ({ type: actionDefinitions.HIDE_CLUSTER_MODAL });

export const setClusterAssignModalSelectedValues = (payload: SelectedValues) => ({
  type: actionDefinitions.SET_CLUSTER_ASSIGN_MODAL_SELECTED_VALUES,
  payload,
});
